function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.10855 18.2134C11.3088 18.2134 13.3297 17.4263 14.9076 16.123L18.5686 19.784C18.7113 19.9268 18.898 20 19.0848 20C19.2715 20 19.4582 19.9268 19.601 19.784C19.8865 19.4984 19.8865 19.0335 19.601 18.7479L15.9546 15.1016C17.3604 13.4981 18.2134 11.4003 18.2134 9.10855C18.2134 4.08567 14.1278 0 9.10489 0C4.08201 0 0 4.08201 0 9.10489C0 14.1278 4.08567 18.2134 9.10855 18.2134ZM9.10855 1.46074C13.3224 1.46074 16.7527 4.88742 16.7527 9.10489C16.7527 13.3223 13.3224 16.749 9.10855 16.749C4.89475 16.749 1.4644 13.3187 1.4644 9.10489C1.4644 4.89109 4.89475 1.46074 9.10855 1.46074Z",
  fill: "white"
});

function SvgHeaderSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSearch);
export default __webpack_public_path__ + "static/media/header_search.9f3b659e.svg";
export { ForwardRef as ReactComponent };